<div class="w-full flex flex-col gap-4 p-4" [formGroup]="form">
    <p-card class="md:max-w-250">
        <div class="w-full flex flex-col gap-4">
            <h1 class="text-2xl font-bold">Email > Cadastro</h1>

            <div class="w-full grid sm:grid-cols-12 grid-cols-1 gap-4 items-end">
                <app-date
                    [label]="'Data Hora para Disparo'"
                    formControlName="DataEnvio"
                    class="sm:col-span-4"
                ></app-date>

                <div
                    class="sm:col-span-8 flex flex-wrap gap-x-6 gap-y-2 min-h-8 items-center"
                >
                    <app-checkbox
                        label="Base de Usuarios"
                        formControlName="EnviaUsuario"
                    ></app-checkbox>

                    <app-checkbox
                        label="Base de Empresa"
                        formControlName="EnviaCliente"
                    ></app-checkbox>

                    <app-checkbox
                        label="Apenas Contadores"
                        formControlName="EnviaContador"
                    ></app-checkbox>

                    <app-checkbox label="Envio Imediato"></app-checkbox>
                </div>

                <app-input
                    [label]="'Assunto'"
                    formControlName="Assunto"
                    class="sm:col-span-6"
                ></app-input>

                <app-input
                    [label]="'Título'"
                    formControlName="Titulo"
                    class="sm:col-span-6"
                ></app-input>

                <p-editor
                    formControlName="TextoBlob"
                    [style]="{ height: '320px' }"
                    class="sm:col-span-12"
                ></p-editor>
            </div>

            <div
                class="w-full flex sm:flex-row flex-col gap-4 justify-end items-end"
            >
                <app-button
                    variant="danger"
                    (click)="cancelar()"
                    class="md:max-w-45 w-full"
                    >Cancelar</app-button
                >

                <app-button
                    variant="success"
                    (click)="salvarEmail()"
                    class="md:max-w-45 w-full"
                    >Salvar</app-button
                >
            </div>
        </div>
    </p-card>
</div>
